/**
 * Gate SMSWiser catalog GETs to match backend @Permissions("smswiser.catalog").
 * For Media Devoted | Created By Ciro Autiero
 */

import { useAuth } from '@/providers/AuthProvider';

export function useSmswiserCatalogApiEnabled(enabled: boolean): boolean {
  const { hasPermission } = useAuth();
  return enabled && hasPermission('smswiser.catalog');
}
